export default __webpack_public_path__ + "static/media/creditCardLogo.dcd259a9.svg";